import { Controller } from "@hotwired/stimulus";

// data-controller="cascade-select"
export default class extends Controller {
  static targets = ["parent", "child"];

  connect() {
    if (this.hasParentTarget && this.parentTarget.value) {
      this.updateChild();
    }
  }

  updateChild() {
    const parentValue = this.parentTarget.value;
    const childSelect = this.childTarget;

    const url = this.data.get("url");
    const param = this.data.get("param") || "parent_id";

    childSelect.innerHTML = '<option value="">Select...</option>';

    if (!parentValue || !url) return;

    fetch(`${url}?${param}=${encodeURIComponent(parentValue)}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        data.forEach((item) => {
          const option = document.createElement("option");
          option.value = item.id;
          option.text = item.name;
          childSelect.appendChild(option);
        });

        if (childSelect.dataset.selected) {
          childSelect.value = childSelect.dataset.selected;
        }
      })
      .catch((error) => {
        console.error("Cascade select error:", error);
      });
  }
}
